import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BlankPageMediaWrapper = ({
  'data-test-id': dataTestId,
  children,
  itemRightComponent
}) => {
  const {
    isDesktop,
    isMobile
  } = useMediaQuery();
  const ItemRightComponent = itemRightComponent;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": dataTestId,
    flexDirection: isMobile ? 'column' : undefined,
    gap: isDesktop ? '1500' : '900',
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(View, {
      maxInlineSize: "372px",
      children: children
    }), /*#__PURE__*/_jsx(ItemRightComponent, {
      inlineSize: isMobile ? '100%' : undefined
    })]
  });
};
export default BlankPageMediaWrapper;